// Body for POST /api/sessions/book. The schema (src/schemas/session.ts)
// rejects serviceId/modality on emergency bookings and requires them
// otherwise, so the two shapes are built in one place instead of inline
// conditionals in the wizard.
export function buildBookRequestBody(args: {
  therapistId: string;
  serviceId: string | null;
  date: string;
  time: string;
  paymentMethod: string;
  modality: "online" | "in_person";
  matchingResultToken?: string | null;
  emergency: boolean;
  /** Firma sufinansira, klijent plaća samo svoj dio (paymentMethod monri/bank_transfer). */
  companyFunding?: boolean;
  /** Ostali članovi (usluga sa više članova); prazno se ne šalje. */
  memberEmails?: string[];
}): Record<string, unknown> {
  const funding = args.companyFunding ? { companyFunding: true } : {};
  if (args.emergency) {
    return {
      therapistId: args.therapistId,
      date: args.date,
      time: args.time,
      paymentMethod: args.paymentMethod,
      emergency: true,
      ...funding,
    };
  }
  return {
    therapistId: args.therapistId,
    serviceId: args.serviceId,
    date: args.date,
    time: args.time,
    paymentMethod: args.paymentMethod,
    modality: args.modality,
    ...(args.matchingResultToken ? { matchingResultToken: args.matchingResultToken } : {}),
    ...(args.memberEmails?.length ? { memberEmails: args.memberEmails } : {}),
    ...funding,
  };
}
